import React, { useEffect } from 'react'

import { WTPayload } from '@f-fertighaus/applications/Next/types/WTPayload'

interface QuestionRadioButtonProps {
  onClick: () => void
  wtData: Omit<WTPayload, 'action' | 'category' | 'values'>
  children: React.ReactNode
}

const QUESTION_RADIO_BUTTON_CLASS_NAME = 'QuestionRadio-button'

export const QuestionRadioButton = ({
  onClick,
  wtData,
  children
}: QuestionRadioButtonProps) => {
  const blockQuestionButtons = () => {
    document
      .querySelectorAll(`.${QUESTION_RADIO_BUTTON_CLASS_NAME}`)
      ?.forEach(x => {
        x.setAttribute('disabled', '')
      })
  }

  const unblockQuestionButtons = () => {
    document
      .querySelectorAll(`.${QUESTION_RADIO_BUTTON_CLASS_NAME}`)
      ?.forEach(x => {
        x.removeAttribute('disabled')
      })
  }

  const handleKeyDown = event => {
    if (event.key === 'Enter' || event.key === 'Space' || event.key === ' ') {
      event.preventDefault()
      event.target.click()
      blockQuestionButtons()
    }
  }

  useEffect(() => {
    unblockQuestionButtons()
  }, [])

  const handleClick = event => {
    window._wt({
      category: 'button',
      action: 'click',
      values: [
        { type: 'text', value: event.target.textContent.trim() || '(ICON)' }
      ],
      ...wtData
    })
    onClick()
    blockQuestionButtons()
  }

  return (
    <button
      className={QUESTION_RADIO_BUTTON_CLASS_NAME}
      onKeyDown={handleKeyDown}
      onClick={handleClick}>
      {children}
    </button>
  )
}
